<template>
    <b-modal v-model="show" title="ПАРАМЕТР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                        <v-select
                                label="label"
                                v-model="dictionaryData.data.province"
                                :filterable="false"
                                :options="provinces"
                                @search="onProvinceSearch"
                                @search:focus="onProvinceFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.region")}} <span class="red">*</span></label>
                        <v-select label="label"
                                :options="regions"
                                v-model="dictionaryData.data.region"
                                :filterable="false"
                                @search="onRegionSearch"
                                @search:focus="onRegionFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.region.id.$error">
                            {{$t("realEstate.validation.region")}}
                        </div>
                    </div>
                    <div class="form-group">
                      <label>{{$t("newRealEstate.field.plus.mfy")}} <span class="red">*</span></label>
                      <v-select v-model="mfy" label="name"
                                :options="mfyList"
                                :filterable="false"
                                @search:focus="mfyFocus"
                                @search="mfySearch"
                                @change="onMfyChange"
                      >
                        <template slot="option" slot-scope="option" v-if="option && option.name">
                          <div v-html="option.name"></div>
                        </template>
                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                    </div>
                    <div class="form-group">
                        <label>{{$t('realEstate.field.microRegion')}}</label>
                        <v-select label="label"
                                  :options="microRegions"
                                  v-model="dictionaryData.data.microRegion"
                                  @search="onMicroRegionSearch"
                        >
                            <template slot="option" slot-scope="option" v-if="option">
                                <div v-html="option.label"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-12">
                                <label>Бино категориялари <span class="red">*</span></label>
                            </div>
                            <div class="col-12">
                                <div :class="{invalid: $v.dictionaryData.data.categories.$error}">
                                    <div class="form-check pl-0 checkbox-inline">
                                        <label class="form-check-label"
                                               style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   value="NotResidential"
                                                   v-model="dictionaryData.data.categories"
                                            >
                                            <span class="form-check-sign"></span>
                                            Нотурар
                                        </label>
                                    </div>
                                    <div class="form-check checkbox-inline">
                                        <label class="form-check-label"
                                               style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   value="ResidentialIndividual"
                                                   v-model="dictionaryData.data.categories"
                                            >
                                            <span class="form-check-sign"></span>
                                            Турар
                                        </label>
                                    </div>
                                    <div class="form-check checkbox-inline">
                                        <label class="form-check-label"
                                               style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   value="ResidentialMultiStorey"
                                                   v-model="dictionaryData.data.categories"
                                            >
                                            <span class="form-check-sign"></span>
                                            Кўпқаватли
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Уй-жой тури <span class="red">*</span></label>
                                    <select class="form-control"
                                            v-model="housingType"
                                    >
                                        <option value="new_buildings">Янги қурилган уйлар</option>
                                        <option value="secondary_market">Олдин курилган</option>
                                    </select>
<!--                                    <div class="red" v-if="$v.housingType.$error">-->
<!--                                       Тураржой турини танланг-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Фойдаланиш максади</label>
                        <v-select label="name"
                                  :options="buildingTypes"
                                  v-model="buildingType"
                        >
                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                <div v-html="option.name"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-6">
                                <label>Сўмдан <span class="red">*</span></label>
                                <numeric-input v-model="dictionaryData.data.minAmount"></numeric-input>
                                <div class="red" v-if="$v.dictionaryData.data.minAmount.$error">Илтимос кийматни киритинг</div>
                            </div>
                            <div class="col-md-6">
                                <label>Гача <span class="red">*</span></label>
                                <numeric-input v-model="dictionaryData.data.maxAmount"></numeric-input>
                                <div class="red" v-if="$v.dictionaryData.data.maxAmount.$error">Илтимос кийматни киритинг</div>
                                <div class="red" v-if="$v.maxA.$error">
                                    {{dictionaryData.data.minAmount}} сўм - кийматдан катта булиш керак
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show = false">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required,minLength,minValue,requiredUnless} from 'vuelidate/lib/validators';
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        name: "AnalogSettingEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterMfy: initFilterModel(),
                filterMicroRegion: new AdvancedFilter(),
                dictionaryData: this.initData(),
                provinces: [],
                regions: [],
                microRegions: [],
                buildingType: null,
                buildingTypes: [],
                housingType: null,
                mfyList: [],
                mfy: null
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        province: {
                            id: {
                                required
                            }
                        },
                        region: {
                            id: {
                                required
                            }
                        },
                        categories: {
                            required: required,
                            minLength: minLength(1)
                        },
                        minAmount: {
                            required: required,
                            minValue: minValue(0.01)
                        },
                        maxAmount: {
                            required: required,
                            minValue: minValue(0.01)
                        }
                    }
                },
                maxA: {
                    required: requiredUnless(() => {
                        return !!(this.validMax)
                    })
                },
               /* housingType: {
                    required: requiredUnless(() => {
                        return !this.isNewBuild
                    })
                } */
            }
        },
        computed: {
            validMax() {
                return this.dictionaryData.data.maxAmount >= this.dictionaryData.data.minAmount;
            },
            isNewBuild() {
                return this.dictionaryData.data.categories.includes('ResidentialMultiStorey')
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'REAL_ESTATE_ANALOG_SETTING',
                    data: {
                        province: null,
                        region: null,
                        microRegion: null,
                        categories: [],
                        minAmount: 0,
                        maxAmount: 0,
                        type: null,
                        housingType: null
                    }
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const request = this.initData();
                request.data.province = this.getShortData(this.dictionaryData.data.province);
                request.data.region = this.getShortData(this.dictionaryData.data.region);
                request.data.categories = this.dictionaryData.data.categories;
                request.data.minAmount = this.dictionaryData.data.minAmount;
                request.data.maxAmount = this.dictionaryData.data.maxAmount;

                if (this.dictionaryData.data.microRegion && this.dictionaryData.data.microRegion.id > 0) {
                    request.data.microRegion = this.getShortData(this.dictionaryData.data.microRegion);
                }

                if (this.dictionaryData.id) {
                    request.id = this.dictionaryData.id;
                }

                if (this.buildingType) {
                    request.data.type = this.buildingType.code;
                }

                if (this.housingType) {
                    request.data.housingType = this.housingType;
                } else {
                    request.data.housingType = null
                }

                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save', request)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.mfy = null
                            this.$emit('change');
                        }
                        vm.processing = false;
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            getShortData(data) {
                return {
                    id: data.id,
                    label: data.label
                }
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
          mfyFocus() {
            this.mfyList = [];
            if (!this.mfy) {
              this.filterMfy.search = '';
            }

            console.log('code = ', this.dictionaryData.data.region)
            this.filterMfy.code = (this.dictionaryData.data.region && this.dictionaryData.data.region.code) ? this.dictionaryData.data.region.code : "";
            this.$http.post('/mfy/search', this.filterMfy)
                .then(res => {
                  this.mfyList = res.data.data;
                }, err => {
                  console.log(err);
                });
          },
          mfySearch(searchTxt, loading) {
            loading(true);
            this.mfyList = [];
            this.filterMfy.search = searchTxt;
            this.filterMfy.code = (this.dictionaryData.data.region && this.dictionaryData.data.region.code) ? this.dictionaryData.data.region.code : "";
            this.$http.post('/mfy/search', this.filterMfy)
                .then(res => {
                  this.mfyList = res.data.data;
                  loading(false);
                }, err => {
                  console.log(err);
                });
          },
          onMfyChange() {
            this.microRegions = [];
            if (this.mfy) {
              this.$http.get(`/micro-regions/by-mfy/${this.mfy.mfyId}`)
                  .then(res => {
                    this.microRegions = this.getAsMaps(res);
                  }, err => {
                    console.log(err);
                  });
            }
          },
            onMicroRegionSearch(searchTxt, loading) {
                loading(true);
                this.microRegions = [];
                this.filterMicroRegion.search = searchTxt;
                this.filterMicroRegion.region = (this.dictionaryData.data.region && this.dictionaryData.data.region.id) ? this.dictionaryData.data.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, label: d.name, code: d.code}))
                }
                return [];
            }
        },
        created() {
           this.filterProvince.page.size = 1000;
           this.filterRegion.page.size = 1000;
           this.filterMicroRegion.pageFilter.size = 1000;

           const vm = this;
           this.$eventBus.$on('showAnalogSettingsModal', (data) => {
               this.$http.get('admin/new-real-estate/building-types')
                   .then(res => {
                       vm.buildingTypes = res.data;
                   }, err => {
                       console.log(err);
                   });

               if (data) {
                   this.dictionaryData = clone(data);
                   if (this.dictionaryData.data.type) {
                       vm.buildingType = vm.buildingTypes.filter((t) => t.code === this.dictionaryData.data.type)[0]
                   }
               } else {
                   this.dictionaryData = this.initData();
                   this.buildingType = null
                   this.housingType = null
               }
               this.show = true;
           });
        }
    }
</script>

<style scoped>

</style>